import { Injectable } from '@angular/core';
import { get } from 'lodash';

import { AudioService } from 'src/app/services/audio/audio.service';
import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';

@Injectable({
	providedIn: 'root',
})
export class MicrophoneDefaultValueService {
	readonly TOGGLE_ON: boolean = true;
	readonly VOLUME_DEFAULT: number = 70;
	readonly OPTIMIZE_MODE_DEFAULT: string = 'OnlyMyVoice';

	constructor(
		private logger: LoggerService,
		private dashboardService: DashboardService,
		private audioService: AudioService
	) {}

	initialize(adTags: any): void {
		const microphoneTag = get(adTags, DeviceSettingsFeatureToggle.MicrophoneSettings);
		const isMicrophoneAdPolicyEnabled = microphoneTag === ADPolicyState.ENABLED;
		this.logger.info('MicrophoneDefaultValueService initialize', {
			microphoneTag,
			isMicrophoneAdPolicyEnabled,
		});

		if (isMicrophoneAdPolicyEnabled) {
			this.setDefaultValue();
		}
	}

	private async setDefaultValue(): Promise<void> {
		this.logger.info(
			'MicrophoneDefaultValueService setDefaultValue for all microphone features'
		);

		if (this.dashboardService.isShellAvailable) this.microphoneToggleON();

		if (this.audioService.isShellAvailable) {
			await this.optimizationMicrophoneDefault();
			this.microphoneVolumeDefault();
			this.suppressKeyboardNoise();
			this.acousticEchoCancellation();
		}
	}

	private async microphoneToggleON(): Promise<void> {
		try {
			await this.dashboardService.setMicrophoneStatus(this.TOGGLE_ON);
		} catch (error) {
			this.logger.error('MicrophoneDefaultValueService microphoneToggleON Error - ', error);
		}
	}

	private async microphoneVolumeDefault(): Promise<void> {
		try {
			await this.audioService.setMicrophoneVolume(this.VOLUME_DEFAULT);
		} catch (error) {
			this.logger.error(
				'MicrophoneDefaultValueService microphoneVolumeDefault Error - ',
				error
			);
		}
	}

	private async suppressKeyboardNoise(): Promise<void> {
		try {
			this.logger.info('MicrophoneDefaultValueService suppressKeyboardNoise');
			await this.audioService.setSuppressKeyboardNoise(this.TOGGLE_ON);
		} catch (error) {
			this.logger.error(
				'MicrophoneDefaultValueService suppressKeyboardNoise Error - ',
				error
			);
		}
	}

	private async acousticEchoCancellation(): Promise<void> {
		try {
			await this.audioService.setMicrophoneAEC(this.TOGGLE_ON);
			this.logger.info('MicrophoneDefaultValueService acousticEchoCancellation');
		} catch (error) {
			this.logger.error(
				'MicrophoneDefaultValueService acousticEchoCancellation Error - ',
				error
			);
		}
	}

	private async optimizationMicrophoneDefault(): Promise<void> {
		try {
			await this.audioService.setMicrophoneOpitimaztion(this.OPTIMIZE_MODE_DEFAULT);
		} catch (error) {
			this.logger.error(
				'MicrophoneDefaultValueService optimizationMicrophoneDefault Error - ',
				error
			);
		}
	}
}
